import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography, Collapse, Checkbox, IconButton, Rating, } from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';
import { useCourseDetail, useNewCourseDetail, useNewCourseDetail1, useNewCourseDetailPro, useNewCourseDetailPro1, useReviews } from '../../assets/api/useGetApi';
import { SkeletonCom, TextSkeleton } from '../../shared/utils/SkeletonCom';
import HtmlWhitelistRenderer from '../../shared/components/HtmlWhitelistRenderer';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import TabPanel from '../../shared/components/Tabs/TabPanel';
import useTabs from '../../shared/hook/useTabs';
import TabComponentsForCourse from '../../shared/components/Tabs/TabComponentsForCourse';
import CourseAccordianCom from '../../shared/components/CourseAccordianCom';
import CustomDivider from '../../shared/utils/CustomDivider';
import useResponsive from '../../shared/utils/Responsive';
import { Page_Padding } from '../../shared/constants';
import usePriceStore from '../../shared/store/usePriceStore';
import SubscribedCardTypeThree from './SubscribedCardTypeThree';
import { useEffect, useMemo, useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SubscribedCard from './SubscribedCard';
import useAuthStore from '../../shared/store/useAuthStore';
import { useToaster } from '../../shared/utils/ToasterProvider';
import ReviewRatingCom from '../../shared/components/ReviewRatingCom';
import StarIcon from '@mui/icons-material/Star';

const TopSection = ({ item, index }) => {
  const { apartments_id } = useParams();
  const finalSprintPrice = item.sprints.reduce((total, sprint) => {
    const price = parseFloat(sprint.price);
    return total + (!isNaN(price) ? price : 0);
  }, 0);

  return (
    <Box sx={{ borderBottom: "1px solid #DEDEDE", pb: 3 }}>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant='h5' fontWeight={"500"}>  {apartments_id ? item?.milestone_name : item?.name} - Milestone{index + 1} </Typography>
        {/* <Typography variant="h5" sx={{ display: "flex", alignItems: "center" }}>
              <CurrencyRupeeIcon sx={{ color: "red.main" }} />
              {finalSprintPrice || '0'}
            </Typography> */}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box>
          {/* <Typography variant='h6' fontWeight={"500"}>{item?.name}</Typography> */}
          <Typography variant='body1' mt={1.5}>Description</Typography>
          <Typography variant='body2' color='grey.400'>{item?.description}</Typography>
          <Typography variant='body1' mt={1.5}>Learning Outcome</Typography>
          <Typography variant='body2' color='grey.400'>{item?.learningOutcome}</Typography>
        </Box>
      </Box>

    </Box>
  )
}

export const BulletList = ({ title, items }) => {
  return (
    <>
      <Typography variant="h5">{title}</Typography>
      <List>
        {Array.isArray(items)
          ? items?.map((item, index) => (
            <ListItem key={index} sx={{ alignItems: "flex-start" }}>
              <ListItemIcon sx={{ minWidth: "20px", mt: "8px" }}>
                <FiberManualRecordIcon sx={{ fontSize: 10, color: "text.secondary" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body2" color="grey.400">
                    {item}
                  </Typography>
                }
              />
            </ListItem>
          ))
          : Object.entries(items)?.map(([key, value], index) => (
            <ListItem key={index} sx={{ alignItems: "flex-start" }}>
              <ListItemIcon sx={{ minWidth: "20px", mt: "8px" }}>
                <FiberManualRecordIcon sx={{ fontSize: 10, color: "text.secondary" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body2" color="grey.400">
                    {key} : {value}
                  </Typography>
                }
              />
            </ListItem>
          ))
        }
      </List>
    </>
  );
};

const UiUxDevelopement = () => {
  const priceDetail = usePriceStore((state) => state.priceDetail);
  const [checkedTabs, setCheckedTabs] = useState([false, false]);
  const isSmallScreen = useResponsive("sm")
  const { value, handleChange } = useTabs(0);
  const location = useLocation();
  const { courseName } = location.state || {};
  const { slug, apartments_id, apartment } = useParams();
  const { data: coursesDetail, isLoading } = useCourseDetail(slug);
  const { data: newCourse1, isLoading: isNewCourseLaoding1 } = useNewCourseDetail({ slug: slug });
  const { data: newCoursePro, isLoading: isNewCourseLaodingPro } = useNewCourseDetailPro({ slug: slug });
  const isProCourse = newCoursePro?.data?.type === 8
  const newCourse = isProCourse ? newCoursePro : newCourse1
  const isNewCourseLaoding = isProCourse ? isNewCourseLaodingPro : isNewCourseLaoding1
  const isType3 = newCourse1?.data?.type === 3 || newCourse1?.data?.type === 5 || isProCourse;
  const { showToaster } = useToaster();
  const { data: newCoursesDetail1, isLoading: isloadingNewCourses1 } = useNewCourseDetail1({ slug: slug, apartments_id: apartments_id })
  const { data: newCoursesDetailPro, isLoading: isloadingNewCoursesPro } = useNewCourseDetailPro1({ slug: slug })
  const newCoursesDetail = isProCourse ? newCoursesDetailPro : newCoursesDetail1
  const isloadingNewCourses = isProCourse ? isloadingNewCoursesPro : isloadingNewCourses1
  const descriptionData = coursesDetail?.data?.description;
  const [accordionChecks2, setAccordionChecks2] = useState([]);
  const [openIndexes, setOpenIndexes] = useState([]);

  useEffect(() => {
    const milestones = newCoursesDetail?.data?.[0]?.milestones || [];
    const dynamicChecks = milestones?.map(milestone => {
      const sprints = milestone?.sprints || [];
      return {
        start_date: milestone?.start_date,
        end_date: milestone?.end_date,
        milestone_name: milestone?.milestone_name,
        price: milestone?.price,
        reduction_price: milestone?.reduction_price,
        start_date: milestone?.start_date,
        end_date: milestone?.end_date,
        sprints: sprints?.map(sprint => ({
          sprints: sprint,
          checked: true,
        }))
      };
    });

    setAccordionChecks2(dynamicChecks);
  }, [newCoursesDetail]);

  // const totalPrice = accordioaccordionChecks2nChecks2.reduce((sum, milestone) => {
  //   return sum + milestone.sprints.reduce((milestoneSum, sprint) => {
  //     if (sprint.checked) {
  //       const reductionPrice = parseFloat(sprint.sprints?.reduction_price);
  //       const regularPrice = parseFloat(sprint.sprints?.price);
  //       const priceToUse = (!isNaN(reductionPrice) && reductionPrice > 0)
  //         ? reductionPrice
  //         : (!isNaN(regularPrice) ? regularPrice : 0);
  //       return milestoneSum + priceToUse;
  //     }
  //     return milestoneSum;
  //   }, 0);
  // }, 0);

  // const totalPrice = accordionChecks2.reduce((sum, milestone) => {
  //   return sum + milestone.sprints.reduce((milestoneSum, sprint) => {
  //     if (sprint.checked) {
  //       const price = parseFloat(sprint.sprints?.price);
  //       return milestoneSum + (!isNaN(price) ? price : 0);
  //     }
  //     return milestoneSum;
  //   }, 0);
  // }, 0);

  // const totalPrice=newCoursesDetail?.data?.[0]?.course_fees



  const allSprintsChecked = accordionChecks2.every(milestone =>
    milestone?.sprints?.every(sprint => sprint?.checked)
  );

  let totalPrice;

  if (allSprintsChecked) {
    const courseFees = parseFloat(newCoursesDetail?.data?.[0]?.course_fees);
    totalPrice = !isNaN(courseFees) ? courseFees : 0;
  } else {
    totalPrice = accordionChecks2.reduce((sum, milestone) => {
      const allMilestoneSprintsChecked = milestone?.sprints?.every(sprint => sprint?.checked);

      if (allMilestoneSprintsChecked) {
        // All sprints in milestone are checked → use milestone.price * total sessions
        const totalSessions = milestone?.sprints?.reduce((count, sprint) => {
          return count + (sprint?.sprints?.sessions?.length || 0);
        }, 0);
        const milestonePrice = parseFloat(milestone?.price);
        return sum + (!isNaN(milestonePrice) ? milestonePrice * totalSessions : 0);
      } else {
        // Mixed checks → sum only checked sprints by their own price
        const sprintSum = milestone?.sprints?.reduce((milestoneSum, sprint) => {
          if (sprint.checked) {
            const sprintPrice = parseFloat(sprint.sprints?.price);
            const sessionCount = sprint.sprints?.sessions?.length || 0;
            return milestoneSum + (!isNaN(sprintPrice) ? sprintPrice * sessionCount : 0);
          }
          return milestoneSum;
        }, 0);
        return sum + sprintSum;
      }
    }, 0);
  }

  // const handleAccordionCheckChange = (milestoneIndex, sprintIndex, checked) => {
  //   setAccordionChecks2(prev => {
  //     return prev.map((milestone, mIdx) => {
  //       if (mIdx !== milestoneIndex) return milestone;

  //       const updatedSprints = milestone.sprints.map((sprint, sIdx) =>
  //         sIdx === sprintIndex
  //           ? { ...sprint, checked }
  //           : sprint
  //       );

  //       return {
  //         ...milestone,
  //         sprints: updatedSprints,
  //       };
  //     });
  //   });
  // };

const handleAccordionCheckChange = (milestoneIndex, sprintIndex, checked) => {
  setAccordionChecks2(prev => {
    // 🔹 First, build the new state
    const newState = prev?.map((milestone, mIdx) => {
      if (mIdx !== milestoneIndex) return milestone;

      return {
        ...milestone,
        sprints: milestone?.sprints?.map((sprint, sIdx) =>
          sIdx === sprintIndex ? { ...sprint, checked } : sprint
        ),
      };
    });

    // 🔹 Count how many sprints are checked across ALL milestones
    const totalChecked = newState
      .flatMap(m => m?.sprints)
      .filter(s => s?.checked)?.length;

    if (totalChecked === 0) {
      showToaster(
        'Warning',
        'Please select at least one Sprint to purchase.',
        'warning'
      );
      return prev; // ❌ block update, keep old state
    }

    return newState; // ✅ allow update
  });
};




  const [, forceUpdate] = useState(0);

  useEffect(() => {
    forceUpdate(n => n + 1);
  }, [accordionChecks2]);


  // const handleCheckboxChange = (tabIndex) => {
  //   setAccordionChecks2(prev => {
  //     const isAllChecked = prev[tabIndex].sprints.every(sprint => sprint.checked);

  //     const updated = prev.map((milestone, i) =>

  //       i === tabIndex

  //         ? {
  //           ...milestone,
  //           sprints: milestone.sprints.map(sprint => ({
  //             ...sprint,
  //             checked: !isAllChecked,
  //           })),
  //         }
  //         : milestone
  //     );

  //     setCheckedTabs(prevTabs => {
  //       const newTabs = [...prevTabs];
  //       newTabs[tabIndex] = !isAllChecked;
  //       return newTabs;
  //     });

  //     return updated;
  //   });
  // };

  const handleCheckboxChange = (tabIndex) => {
    setAccordionChecks2(prev => {
      // Check if the user is trying to uncheck all sprints of this milestone
      const isAllChecked = prev[tabIndex]?.sprints?.every(sprint => sprint?.checked);

      // Count total checked milestones across all tabs
      const totalCheckedMilestones = prev?.filter(m =>
        m?.sprints?.some(sprint => sprint?.checked)
      )?.length;

      // If this is the last milestone with any sprint checked and user tries to uncheck it
      if (isAllChecked && totalCheckedMilestones === 1) {
        showToaster(
          'Warning',
          'Please select at least one milestone to purchase.',
          'warning'
        );
        return prev; // Don't update state
      }

      // Otherwise proceed with checking/unchecking logic
      const updated = prev?.map((milestone, i) =>
        i === tabIndex
          ? {
            ...milestone,
            sprints: milestone?.sprints?.map(sprint => ({
              ...sprint,
              checked: !isAllChecked,
            })),
          }
          : milestone
      );

      setCheckedTabs(prevTabs => {
        const newTabs = [...prevTabs];
        newTabs[tabIndex] = !isAllChecked;
        return newTabs;
      });

      return updated;
    });
  };

  function filterCourseByChecks(course, accordionChecks) {
    if (!course?.milestones || !accordionChecks) return course;
    const filteredMilestones = course?.milestones?.map((milestone, idx) => {
      const sprintChecksWrapper = accordionChecks[idx]?.sprints || [];
      const filteredSprints = sprintChecksWrapper
        ?.filter(sprintCheck => sprintCheck.checked === true)
        ?.map(sprintCheck => sprintCheck?.sprints);
      return {
        ...milestone,
        sprints: filteredSprints,
      };
    });

    return {
      ...course,
      milestones: filteredMilestones,
    };
  }

  const Loader = () => {
    return (
      <>

        <TextSkeleton line={5} />
        <CustomDivider />
        <Grid2 container spacing={"1rem"}>
          {
            [...Array(3)]?.map((_, index) => (
              <Grid2 size={12} key={index}>
                <SkeletonCom />
              </Grid2>

            ))
          }
        </Grid2>

      </>
    )
  }
  const filteredCourse = filterCourseByChecks(newCoursesDetail?.data?.[0], accordionChecks2);
  const course_id = newCourse?.data?.id;
  const { data: reviewsData, isLoading: isReviewsLoading } = useReviews(course_id, { page: 1, limit: 10 });

  const tabData1 = newCourse?.data?.milestones?.map((item, index) => {
    return {
      label: item?.name,
      component: (
        <>
          {isNewCourseLaoding ? <Loader /> : <>
            <TopSection item={item} index={index} />
            {item?.sprints
              ?.filter((sprintItem) => sprintItem?.sprint_id !== null)
              .map((sprintItem, sprintIndex) => (
                <CourseAccordianCom
                  key={sprintItem?.sprint_id || sprintIndex}
                  title={`Semester 1 Section ${sprintIndex + 1}`}
                  item={sprintItem}
                  index={sprintIndex}
                />
              ))}
          </>}


        </>
      ),
    };
  });

  const tabData12 = useMemo(() => {
    if (!newCoursesDetail || accordionChecks2?.length === 0) return [];
    return newCoursesDetail?.data[0]?.milestones?.map((milestone, milestoneIndex) => {
      return {
        label: milestone?.milestone_name,
        component: (
          <>
            {
              isloadingNewCourses ? <Loader /> : <>
                <TopSection item={milestone} index={milestoneIndex} />
                {milestone?.sprints
                  ?.map((sprintItem, originalIndex) => ({ sprintItem, originalIndex }))
                  .filter(({ sprintItem }) => sprintItem?.sprint_id !== null)
                  .map(({ sprintItem, originalIndex }) => (
                    <CourseAccordianCom
                      isCheckBox={true}
                      key={sprintItem?.sprint_id || originalIndex}
                      item={sprintItem}
                      index={originalIndex}
                      action={accordionChecks2[milestoneIndex]?.sprints?.[originalIndex]?.checked}
                      onActionChange={(checked) =>
                        handleAccordionCheckChange(milestoneIndex, originalIndex, checked)
                      }
                    />
                  ))}
              </>
            }

          </>
        )
      };
    });
  }, [newCoursesDetail, accordionChecks2, openIndexes,]);



  const toggleAccordion = (index) => {
    setOpenIndexes(prev => {
      const newIndexes = prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index];
      return newIndexes;
    });
  };

  const renderAccordian = () => {
    return (
      <>
        {accordionChecks2?.map((sprintsArray, milestoneIndex) => (
          <Box key={milestoneIndex} mb={2}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                cursor: 'pointer',
                p: 1,
                borderRadius: 1,
              }}
              onClick={() => toggleAccordion(milestoneIndex)}
            >
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Checkbox
                  checked={accordionChecks2[milestoneIndex]?.sprints?.every(sprint => sprint?.checked === true)}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() =>
                    handleCheckboxChange(milestoneIndex)
                  }
                  sx={{
                    color: 'red.main',
                    '&.Mui-checked': { color: 'red.main' },
                  }}
                />
                <Box>
                  <Typography
                    variant="body1"
                    color={
                      sprintsArray?.sprints?.some((item) => item?.checked === false)
                        ? 'grey.400'
                        : 'inherit'
                    }
                  >
                    {sprintsArray?.milestone_name}
                  </Typography>

                  {sprintsArray?.start_date && sprintsArray?.end_date && (
                    <Typography
                      variant="body2"
                      color="grey.400"
                      mb={1}
                      fontSize="0.7rem"
                    >
                      <span>From Date : </span>{sprintsArray.start_date}
                      &nbsp;&nbsp;&nbsp;
                      <span>To Date :</span> {sprintsArray.end_date}
                    </Typography>
                  )}

                </Box>

              </Box>

              <IconButton size="small" onClick={(e) => {
                e.stopPropagation();
                toggleAccordion(milestoneIndex);
              }}>
                {openIndexes.includes(milestoneIndex) ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )}
              </IconButton>

            </Box>

            <Collapse in={openIndexes.includes(milestoneIndex)} timeout="auto" unmountOnExit sx={{ bgcolor: "#F8F8F8" }}>
              {sprintsArray?.sprints
                ?.filter((item) => item?.sprints?.sprint_id !== null)
                .map((item, lessonIndex) => (
                  <Box key={lessonIndex} sx={{ display: 'flex', alignItems: 'start', mt: 1, ml: 2 }}>
                    <Checkbox
                      checked={item.checked || false}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e, checked) =>
                        handleAccordionCheckChange(milestoneIndex, lessonIndex, checked)
                      }
                      sx={{
                        color: isProCourse ? "red.main" : "grey",
                        "&.Mui-checked": {
                          color: isProCourse ? "red.main" : "grey",
                        },
                        mr: 1,
                      }}
                      disabled={!isProCourse}
                    />
                    <Box>
                      <Typography variant="body2" color={item.checked ? 'inherit' : 'grey.600'}>
                        {item.sprints?.name}
                      </Typography>

                    </Box>
                  </Box>
                ))}
            </Collapse>
          </Box>
        ))}
      </>
    )
  }
  const title = courseName || coursesDetail?.data?.title || newCourse?.data?.title || '';


  return (
    <>
      <Grid2 container spacing={5} px={Page_Padding}>
        <Grid2
          size={{ xs: 12, lg: 7 }}
          sx={{
            maxHeight: { xs: 'auto', lg: '70vh' },
            overflowY: { xs: 'auto', lg: 'scroll' },
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          {((isloadingNewCourses && isNewCourseLaoding) && !title) && <TextSkeleton line={1} width="100%" />}
          {title && (
            isType3 ? <Typography variant="h5" fontWeight={600} mb={2} color="#1A1A1A">
              {title}{(newCoursesDetail?.data?.[0]?.apartment_name && apartments_id) && `-${newCoursesDetail.data[0].apartment_name}`}
            </Typography> : <Typography variant="h5" fontWeight={600} mb={2} color="#1A1A1A">
              {title} {apartment && `-${apartment}`}
            </Typography>
          )}
          {(!isloadingNewCourses && !isNewCourseLaoding) && (
            <>

              {isType3 && apartments_id &&
                <>
                  {

                    newCoursesDetail?.data?.[0]?.sessions?.slice().reverse().map((item, index) => (
                      <Typography>
                        {item?.day}
                        {item?.start_time && item?.end_time
                          ? ` From: ${item.start_time} - To: ${item.end_time}`
                          : ""}
                      </Typography>

                    ))
                  }

                </>


              }
              {
                isType3 && <Typography>Age Group : {newCoursesDetail?.data?.[0]?.age_min}-{newCoursesDetail?.data?.[0]?.age_max} Years</Typography>
              }
              {
                isProCourse &&
                <>
                  <Typography>No of live class : {newCoursesDetail?.data?.[0]?.no_of_live_class}</Typography>
                  <Typography>No of teachers : {newCoursesDetail?.data?.[0]?.no_of_teachers}</Typography>
                </>

              }

            </>

          )}

          {isSmallScreen && priceDetail && (
            <Box mt={2}>
              <Typography variant='body2'> <span className='dateheading'>From Date : </span> {priceDetail?.start_date}&nbsp; &nbsp; &nbsp;  <span className='dateheading'>To Date</span> : {priceDetail?.end_date}</Typography>
              <Typography variant='body2' mt={1}> <span className='dateheading'>Start Time </span>: {priceDetail?.start_time}&nbsp; &nbsp; &nbsp;  <span className='dateheading'>End Time</span> : {priceDetail?.end_time}</Typography>
            </Box>
          )
          }

          {descriptionData?.Objective && (
            <Box my={5}>
              {isLoading ? (
                <TextSkeleton line={4} width="100%" />
              ) : (
                <HtmlWhitelistRenderer html={descriptionData.Objective} />
              )}
            </Box>
          )}

          {newCourse?.data && (
            <Box my={5}>
              {isNewCourseLaoding ? (
                <TextSkeleton line={4} width="100%" />
              ) : (
                <>
                  <Typography variant="h5" gutterBottom >
                    Description
                  </Typography>
                  <HtmlWhitelistRenderer html={newCourse?.data?.description} />
                </>

              )}
            </Box>
          )}

          {newCourse?.data && (
            <Box my={5}>
              {isNewCourseLaoding ? (
                <TextSkeleton line={4} width="100%" />
              ) : (
                <>
                  <HtmlWhitelistRenderer html={newCourse?.data?.short_description} />
                </>

              )}
            </Box>
          )}

          {descriptionData?.Outcomes && (
            <Box my={5}>
              {isLoading ? (
                <TextSkeleton line={4} width="100%" />
              ) : (
                <Box>
                  <Typography variant="h5" gutterBottom >
                    Outcomes
                  </Typography>
                  {Object.entries(descriptionData?.Outcomes)?.map(
                    ([rawKey, rawValue], idx) => (
                      <Box key={idx} mb={1} pl={1}>
                        <HtmlWhitelistRenderer html={`${rawKey} ${rawValue}`} />
                      </Box>
                    )
                  )}
                </Box>
              )}
            </Box>
          )}

          {descriptionData?.Conclusion && (
            <Box my={5}>
              {isLoading ? (
                <TextSkeleton line={4} width="100%" />
              ) : (
                <HtmlWhitelistRenderer html={descriptionData?.Conclusion} />
              )}
            </Box>
          )}

          {
            isType3 && (
              <>

                {
                  isNewCourseLaoding ? (
                    <TextSkeleton line={4} width="100%" />
                  ) : (
                    !apartments_id && (
                      <>
                        <CustomDivider />
                        <TabComponentsForCourse
                          tabs={tabData1}
                          value={value}
                          onChange={handleChange}
                        />
                        {tabData1?.map((tab, index) => (
                          <TabPanel key={index} value={value} index={index}>
                            {tab?.component}
                          </TabPanel>
                        ))}
                      </>
                    )
                  )
                }


                {
                  apartments_id && (
                    <>
                      {!isLoading && newCoursesDetail && accordionChecks2?.length > 0 && tabData12?.length > 0 && (
                        <>
                          <TabComponentsForCourse
                            isCheckBox={true}
                            tabs={tabData12}
                            value={value}
                            onChange={handleChange}
                            accordionChecks={accordionChecks2}
                            handleCheckboxChange={handleCheckboxChange}
                            isPadding={false}
                          />
                          {tabData12?.map((tab, index) => (
                            <TabPanel key={index} value={value} index={index}>
                              {tab?.component}
                            </TabPanel>
                          ))}
                        </>
                      )}
                    </>
                  )
                }
              </>
            )
          }
        </Grid2>

        {
          !isSmallScreen && (
            <Grid2 size={{ xs: 12, lg: 5 }}>
              {
                isType3 ? <SubscribedCardTypeThree totalPrice={totalPrice} filteredCourse={filteredCourse}>
                  {renderAccordian()}
                </SubscribedCardTypeThree> : <SubscribedCard course_id={newCourse?.data?.id} />
              }

            </Grid2>
          )
        }


      </Grid2>

      <Box px={Page_Padding} my={5}>
        <CustomDivider orientation='horizontal' />
        <Typography variant="h5" mb={3}>Review & Rating</Typography>
        
        {isReviewsLoading ? (
          <TextSkeleton line={3} />
        ) : (
          <>
            {reviewsData?.overallReview && (
              <Box mb={4} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="h2" color="red.main">
                  {reviewsData.overallReview.averageRating}
                </Typography>
                <Box>
                  <Rating
                    value={Number(reviewsData.overallReview.averageRating)} 
                    readOnly 
                    precision={0.5}
                    icon={<StarIcon sx={{ color: "red.main", fontSize: "25px" }} />}
                    emptyIcon={<StarIcon sx={{ fontSize: "25px" }} />}
                  />
                  <Typography variant="body2" color="grey.400">
                    Based on {reviewsData.overallReview.totalReviews} reviews
                  </Typography>
                </Box>
              </Box>
            )}

            {reviewsData?.reviews?.length > 0 ? (
              reviewsData.reviews.map((review, index) => (
                <ReviewRatingCom key={review.id || index} review={review} />
              ))
            ) : (
              <Typography variant="body1" color="grey.400">No reviews yet for this course.</Typography>
            )}
          </>
        )}
      </Box>
    
      {
        isSmallScreen &&
        <>
          {
            isType3 ? <SubscribedCardTypeThree totalPrice={totalPrice} filteredCourse={filteredCourse}>
              {renderAccordian()}
            </SubscribedCardTypeThree> : <SubscribedCard course_id={newCourse?.data?.id} />
          }
        </>


      }

    </>



  );
};


export default UiUxDevelopement;